import React from "react";
import "./Clients.css";
import MainIMG from "./IMG/MainIMG.svg";
import Client from "./IMG/Client.svg";
import Middle from "./IMG/Mid.svg";
import Candidate from "./IMG/Candidate.svg";

const employerPoints = [
  "Define essential skills, role outcomes, location and employment terms before sourcing.",
  "Agree on interview criteria and who is responsible for the final hiring decision.",
  "Keep candidate information limited to what is needed and handle it securely.",
  "Communicate selection stages and feedback timing clearly."
];
const candidatePoints = [
  "Ask for the current job description, location, pay terms and employment type.",
  "Tailor your CV to relevant skills and provide accurate work-history information.",
  "Verify the employer and written offer through independently confirmed channels.",
  "Check official visa or work-authorisation requirements for international roles."
];

function ClientsAndCandidates() {
  return (
    <section className="client-candidate-section" aria-labelledby="client-candidate-heading">
      <div className="client-candidate-intro">
        <h2 id="client-candidate-heading">Guidance for employers and candidates</h2>
        <p>Clear requirements and communication help both sides make informed decisions during recruitment. These practical checks can be used before, during and after a hiring discussion.</p>
      </div>
      <div className="client-candidate-grid">
        <article className="client-candidate-panel">
          <img src={Client} alt="" loading="lazy" />
          <h3>For employers</h3>
          <ul>{employerPoints.map((point) => <li key={point}>{point}</li>)}</ul>
        </article>
        <article className="client-candidate-panel">
          <img src={Candidate} alt="" loading="lazy" />
          <h3>For candidates</h3>
          <ul>{candidatePoints.map((point) => <li key={point}>{point}</li>)}</ul>
        </article>
      </div>
      <div className="client-candidate-visual" aria-hidden="true"><img src={MainIMG} alt="" /><img src={Middle} alt="" /></div>
    </section>
  );
}
export default ClientsAndCandidates;
